import { RoleStatusBadge } from "PFComponents/role/role_status_badge";
import React from "react";
import { humanize, titleize } from "underscore.string";

import ExceptionsPill from "../exceptions_pill";
import { mapWorkflowStatesToUI } from "../helpers";

type AuditRoleStatusBadgeProps = {
  status: string;
  className?: string;
};

export const AuditRoleStatusBadge = ({ status, className }: AuditRoleStatusBadgeProps): JSX.Element =>
  status === "exception" ? (
    <ExceptionsPill />
  ) : (
    <RoleStatusBadge workflowState={mapWorkflowStatesToUI(status)} className={className}>
      {titleize(humanize(mapWorkflowStatesToUI(status)))}
    </RoleStatusBadge>
  );
